import { createAction, props, union } from '@ngrx/store';

export const setFlag = createAction('[PageLeaveConfirmation] Set Flag', props<{ payload: boolean }>());

export const actions = union({ setFlag });
